/* Alizette v3 (base Kopy) : menu mobile, galerie de la fiche, choix de variante. Aucun ajout au panier hors du clic sur un bouton « Ajouter ». */
(function () {
  var b = document.body;
  // menu mobile
  var burger = document.querySelector('[data-d3-burger]');
  var close = document.querySelector('[data-d3-close]');
  var scrim = document.querySelector('[data-d3-scrim]');
  function setMenu(open) {
    b.classList.toggle('d3-menu-open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (burger) burger.addEventListener('click', function () { setMenu(!b.classList.contains('d3-menu-open')); });
  if (close) close.addEventListener('click', function () { setMenu(false); });
  if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  // galerie de la fiche : défilement horizontal, vignettes et flèches
  var gal = document.querySelector('[data-d3-gal]');
  if (gal) {
    var track = gal.querySelector('[data-d3-track]');
    var thumbs = gal.querySelectorAll('[data-d3-thumb]');
    var figs = track ? track.children : [];
    var idx = 0;
    function mark(i) {
      idx = i;
      thumbs.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }
    function go(i) {
      if (!figs.length) return;
      i = Math.max(0, Math.min(figs.length - 1, i));
      track.scrollTo({ left: figs[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var pv = gal.querySelector('[data-d3-prev]'), nx = gal.querySelector('[data-d3-next]');
    if (pv) pv.addEventListener('click', function () { go(idx - 1); });
    if (nx) nx.addEventListener('click', function () { go(idx + 1); });
    if (track) track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i !== idx) mark(i);
    }, { passive: true });
    if (track) track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(idx + 1); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(idx - 1); e.preventDefault(); }
    });
  }

  // variantes et offre (MARK-DUO) : met à jour l'identifiant envoyé, les prix et le bouton
  var form = document.querySelector('[data-d3-form]');
  var dataEl = document.querySelector('[data-d3-product]');
  if (form && dataEl) {
    var product = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var offerBox = form.querySelector('[data-d3-offre]');
    var duoBox = form.querySelector('[data-d3-duo2]');
    var discount = offerBox ? (parseInt(offerBox.getAttribute('data-discount'), 10) || 0) : 0;
    var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
    var pick = function (attr) {
      var vals = [];
      form.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var pos = +el.getAttribute(attr);
        if (el.type === 'radio') { if (el.checked) vals[pos] = el.value; }
      });
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return vals[i] === undefined || vals[i] === o; });
      })[0];
    };
    var offer = function () { var c = form.querySelector('[data-d3-offer]:checked'); return c && c.value === '2' ? 2 : 1; };
    // lu par le script d'ajout au panier : l'offre choisie et la variante de chaque brosse
    form.d3State = function () { var duo = offer() === 2; return { offer: duo ? 2 : 1, v1: pick('data-d3-option'), v2: duo ? pick('data-d3-option2') : null, discount: discount }; };
    var apply = function (moveGallery) {
      var st = form.d3State(), v = st.v1, v2 = st.v2, duo = st.offer === 2;
      if (!v) return;
      idInput.value = v.id;
      form.querySelectorAll('[data-d3-optname]').forEach(function (b) {
        var pos = +b.getAttribute('data-d3-optname');
        var chk = form.querySelector('[data-d3-option="' + pos + '"]:checked');
        if (chk) b.textContent = chk.value;
      });
      form.querySelectorAll('[data-d3-optname2]').forEach(function (b) {
        var pos = +b.getAttribute('data-d3-optname2');
        var chk = form.querySelector('[data-d3-option2="' + pos + '"]:checked');
        if (chk) b.textContent = chk.value;
      });
      if (duoBox) duoBox.hidden = !duo;
      form.classList.toggle('is-duo', duo);
      form.querySelectorAll('[data-d3-leg1]').forEach(function (l) { l.textContent = l.getAttribute(duo ? 'data-two' : 'data-one'); });
      var sub = document.querySelector('[data-d3-sticky-sub]');
      if (sub) sub.textContent = sub.getAttribute(duo ? 'data-two' : 'data-one');
      document.querySelectorAll('[data-d3-price]').forEach(function (p) { p.textContent = money(v.price); });
      var ok = v.available && (!duo || (v2 && v2.available));
      var total = duo ? (v2 ? v.price + v2.price - discount : v.price) : v.price;
      document.querySelectorAll('[data-d3-total]').forEach(function (t) { t.textContent = money(total); t.hidden = !ok; });
      var atc = form.querySelector('[data-d3-atc]');
      if (atc) {
        atc.disabled = !ok;
        var l = atc.querySelector('[data-d3-atc-label]');
        if (l) l.textContent = ok ? l.getAttribute('data-add') : l.getAttribute('data-sold');
      }
      var sb = document.querySelector('.d3-sticky button[form="d3-form"]');
      if (sb) { sb.disabled = !ok; sb.textContent = ok ? 'Ajouter au panier' : 'Épuisé'; }
      if (history.replaceState) history.replaceState({}, '', '?variant=' + v.id + (duo ? '&offre=duo' : '')); /* MARK-FIX : garde l'offre dans l'adresse */
      if (moveGallery !== false && v.featured_media && gal) {
        // la galerie est filtrée par le thème : on retrouve la vignette par l'identifiant du média, pas par sa position
        var t = gal.querySelector('[data-d3-thumb][data-media-id="' + v.featured_media.id + '"]');
        if (t) t.click();
      }
    };
    form.querySelectorAll('[data-d3-option]').forEach(function (el) { el.addEventListener('change', function () { apply(true); }); });
    form.querySelectorAll('[data-d3-option2],[data-d3-offer]').forEach(function (el) { el.addEventListener('change', function () { apply(false); }); });
    // MARK-FIX : ?offre=duo ou #duo présélectionne la carte Duo (sans paramètre : comportement inchangé)
    try {
      var qp = new URLSearchParams(window.location.search);
      var wantDuo = (qp.get('offre') || '').toLowerCase() === 'duo' || window.location.hash.toLowerCase() === '#duo';
      var duoRadio = form.querySelector('[data-d3-offer][value="2"]');
      if (wantDuo && duoRadio) duoRadio.checked = true;
    } catch (e) { /* adresse illisible : offre 1 brosse */ }
    apply(true);
  }
})();

// pictogramme « IA » discret (lien vers les mentions légales) sur toute image dont le texte alternatif la dit générée par IA
// (hors galerie de la fiche et hors cartes déjà équipées ; jamais dans un lien, pour ne pas imbriquer deux liens)
(function () {
  var imgs = document.querySelectorAll('main img[alt*="générée par IA" i], main img[alt*="generee par IA" i]');
  imgs.forEach(function (img) {
    if (img.closest('.d3-fig') || img.closest('a')) return;
    var host = img.closest('.az-ia-host, figure') || img.parentElement;
    if (!host || host.querySelector('.az-iab')) return;
    host.classList.add('az-ia-host');
    var a = document.createElement('a');
    a.className = 'az-iab az-iab--br';
    a.href = '/pages/mentions-legales#ia';
    a.setAttribute('aria-label', 'Image générée par IA, en savoir plus');
    a.title = 'Image générée par IA, en savoir plus';
    a.textContent = 'IA';
    host.appendChild(a);
  });
})();

// barre d'achat collante (mobile) : visible quand le bouton principal est passé au-dessus de l'écran
(function () {
  var bar = document.querySelector('[data-d3-sticky]');
  var atc = document.querySelector('[data-d3-atc]');
  if (!bar || !atc) return;
  var tick = false;
  function check() {
    tick = false;
    bar.classList.toggle('is-on', atc.getBoundingClientRect().bottom < 0);
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
  check();
})();

/* v4 tiroir : ajout au panier (MARK-DUO : offre Duo = 2 variantes en un seul appel items[]) */
(function () {
  var form = document.querySelector('[data-d3-form]');
  if (!form || !window.fetch || !window.FormData) return;
  var busy = false;
  form.addEventListener('submit', function (e) {
    var st = form.d3State ? form.d3State() : { offer: 1 };
    var duo = st.offer === 2 && !!st.v1 && !!st.v2;
    var drawer = document.querySelector('cart-drawer');
    var canDrawer = !!drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    // sans tiroir exploitable : on laisse le formulaire natif partir vers /cart (repli) ; le Duo, lui, ne part jamais en natif (il n'ajouterait qu'une brosse)
    if (!canDrawer && !duo) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var btns = document.querySelectorAll('[data-d3-atc], .d3-sticky button[form="d3-form"]');
    btns.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.classList.add('loading'); });
    var err = form.querySelector('[data-d3-err]');
    if (err) err.hidden = true;
    var end = function () { busy = false; btns.forEach(function (b) { b.removeAttribute('aria-disabled'); b.classList.remove('loading'); }); };
    var secIds = canDrawer ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
    var opts;
    var fd = null;
    if (duo) {
      var items = st.v1.id === st.v2.id ? [{ id: st.v1.id, quantity: 2 }] : [{ id: st.v1.id, quantity: 1 }, { id: st.v2.id, quantity: 1 }];
      var body = { items: items };
      if (secIds.length) { body.sections = secIds.join(','); body.sections_url = window.location.pathname; }
      opts = { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: JSON.stringify(body) };
    } else {
      fd = new FormData(form);
      Array.from(fd.keys()).forEach(function (k) { if (k.indexOf('d3-option-') === 0 || k.indexOf('d3-opt2-') === 0 || k === 'd3-offre') fd.delete(k); });
      fd.append('sections', secIds.join(','));
      fd.append('sections_url', window.location.pathname);
      opts = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd };
    }
    if (canDrawer && drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
    var fallback = function () { end(); if (duo) window.location.href = '/cart'; else form.submit(); };
    var showErr = function (msg) { end(); if (err) { err.textContent = msg || "Ce coloris n'est pas disponible pour le moment. Choisis-en un autre."; err.hidden = false; } };
    fetch(addUrl, opts).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { if (duo) { showErr(res.description || res.message); return null; } fallback(); return null; }
      if (res.sections) return res;
      if (!duo) { fallback(); return null; }
      // items[] : si les sections ne reviennent pas avec l'ajout, on les demande
      return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '?sections=' + secIds.join(','), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (secs) { res.sections = secs; return res; });
    }).then(function (res) {
      if (!res) return;
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: duo ? st.v1.id : fd.get('id'), cartData: res });
      } catch (x) {}
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
      end();
    }).catch(function () { if (duo) showErr('Impossible d\'ajouter les deux brosses pour le moment. Réessaie dans un instant.'); else fallback(); });
  });
})();
